import { useMemo } from 'react';
import { useShowContext } from 'framework/show';
import { DIFF_TAGS, DiffItem } from 'framework/DiffViewer';
import { ComplianceDocumentVersionFinalizeShowData } from './types';

const useComplianceDocumentVersionFinalizeData = () => {
  const { data: contextData } = useShowContext<ComplianceDocumentVersionFinalizeShowData>();
  const data = contextData.getData();

  const { sourceDiff, loadErrors, metadata, documentName, complianceType, hasComparableVersion, paths = [] } = data;

  const percentChanges = useMemo(() => {
    if (!sourceDiff?.differences?.length) return 0;
    const changed = sourceDiff.differences.filter((i: DiffItem) => i.tag !== DIFF_TAGS.EQUAL).length;
    return (changed / sourceDiff.differences.length) * 100;
  }, [sourceDiff]);

  const canShowSourceDiff = hasComparableVersion && !!sourceDiff?.differences?.length && !loadErrors.sourceDiff;

  return {
    documentName,
    complianceType,
    documentPath: paths[0] || '',
    sourceDiff,
    hasComparableVersion,
    isFirstPublish: metadata.version === 1,
    percentChanges,
    hasDiffError: loadErrors.sourceDiff,
    canShowSourceDiff,
  };
};

export default useComplianceDocumentVersionFinalizeData;
